import { ReactNode } from 'react';
import Breadcrumb from './Breadcrumb';

type PageHeadingProps = {
    crumbs?: Array<{
        name: string;
        href: string;
    }>;
    heading?: string;
    headerSibling?: ReactNode;
    leftContent?: ReactNode;
    rightContent?: ReactNode;
    headerClassName?: string;
    headerParentClassName?: string;
    limitWidth?: boolean;
    className?: string;
};

const PageHeading = ({
    crumbs,
    heading,
    leftContent,
    rightContent,
    headerSibling,
    headerClassName,
    headerParentClassName,
    limitWidth = true,
    className = '',
}: PageHeadingProps) => {
    const headingComponent = (
        <div className={`flex gap-2 flex-row items-center ${headerParentClassName}`}>
            <h1
                className={`${!!crumbs ? '!mt-0' : ''} ${headerClassName}`}
            >
                {heading}
            </h1>
            {headerSibling}
        </div>
    );
    return (
        <>
            {!!crumbs && <Breadcrumb crumbs={crumbs} className="mt-8 mb-1" />}
            {leftContent != null && headingComponent}
            <div
                className={`flex flex-wrap sm:flex-nowrap items-center ${!!crumbs ? '' : 'mt-8'} mb-4 justify-between${limitWidth ? ' max-w-2xl' : ''} ${className}`}
            >
                {leftContent}
                {leftContent == null && headingComponent}
                {!!rightContent && <div>{rightContent}</div>}
            </div>
        </>
    );
};

export default PageHeading;
